'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(props) {
    return (0, _wrapField2.default)(props, _react2.default.createElement(_input2.default, (0, _extends3.default)({
        disabled: props.disabled,
        id: props.id,
        name: props.name,
        onChange: function onChange(event) {
            return props.onChange(event.target.value);
        },
        placeholder: props.placeholder,
        ref: props.inputRef,
        type: props.type,
        value: props.value
    }, (0, _filterDOMProps2.default)(props))));
};

Text.defaultProps = { type: 'text' };

exports.default = (0, _connectField2.default)(Text);


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/TextField.js
// module id = 633
// module chunks = 35783957827783 65974612472484